import React from 'react';
import { Card, CardBody, CardHeader, Col, Input, Label, Media } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';
import { SwitchColor } from '../../../../Constant';
import { Switchcolor } from '../../../../Data/FormWidgets';

const BasicColor = () => {
  return (
    <Col sm='12' xl='6' lg='12' md='6'>
      <Card>
        <CardHeader className='pb-0'>
          <H5>{SwitchColor}</H5>
        </CardHeader>
        <CardBody className='row switch-showcase height-equal'>
          <Col sm='12'>
            {Switchcolor.map((item, index) => {
              return (
                <Media className={item.mainclass} key={index}>
                  <Label className='col-form-label m-r-10'>{item.title}</Label>
                  <Media body className={`flex-grow-1 ${item.mediaclass}`}>
                    {item.title === 'Bootstrap Switch' || item.title === 'Disabled checked' ? (
                      <div className='form-check form-switch'>
                        <Input className='form-check-input' defaultChecked={item.checkedclass} disabled={item.disabled} type='checkbox'  />
                      </div>
                    ) : (
                      <Label className='switch'>
                        <Input type='checkbox' defaultChecked={item.checkedclass} />
                        <span className={item.spanclass}></span>
                      </Label>
                    )}
                  </Media>
                </Media>
              );
            })}
          </Col>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BasicColor;
